let Badge = {
	lock: false,
	init: function () {

		let button = document.getElementById('load-badges-btn');
		let content = document.getElementById('load-tools-response');

		if(!Badge.lock) {
			content.innerHTML = "";
			let badge_code = document.getElementById('input-badge-code');
			Badge.lock = true;
			button.setAttribute("disabled", true);
			content.innerHTML += '<div class="box box-big"><div class="body"><center><div class="img-ajax-loader"><img src="/images/loading.gif" class="img-ajax-loader" /></div></center></div></div>';
			Api.get(`/badges/info/${badge_code.value}`, {}, function (r) {
				if (r.success) {
					content.innerHTML = "";
                    let badge_preview = `
                      <div class="box box-big box-blue">
                        <div class="head">Vista de la placa ${r.data.code}</div>
                        <div class="body flex" style="justify-content: center">
                            <img src="//images.habbo.com/c_images/album1584/${r.data.code}.gif" />
                        </div>
                      </div>
                    `;
                    content.insertAdjacentHTML('beforeend', badge_preview);

                    Object.keys(r.data.results).map((hotel) => {
                        let community = `
                            <div class="box box-big box-orange">
                                <div class="head">Hotel (${hotel})</div>
                                <div class="body flex" style="flex-direction: column">
                                    <div>
                                        <h1>Nombres que ha tenido la placa</h1>
                                        <div id="badge_name" class="badge_info_container">
                                            ${Badge.generateText(r.data.results[hotel].name)}
                                        </div>
                                    </div>
                                    <div>
                                        <h1>Descripciones que ha tenido la placa</h1>
                                        <div id="badge_description" class="badge_info_container">
                                            ${Badge.generateText(r.data.results[hotel].description)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
                        content.insertAdjacentHTML('beforeend', community);
                    });

				} else {

				}
				Badge.lock = false;
				button.removeAttribute("disabled");
			});
		}
	},

    generateText: function(data) {
        let string = "";
        for (let item of data) {
            string += `
                <div class="badge_info_data">
                    <h1>${item.text}</h1>
                    <small>Encontrado ${Time.getHTML(item.founded_at)}</small>
                </div>
            `;
        }
        return string;
    }
}
